import * as React from "react";

function IconBrandPagekit({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-pagekit" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/brand-pagekit"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12.077 20h-5.077v-16h11v14h-5.077" /></svg>;
}

export default IconBrandPagekit;